import { CalculatedBudget } from 'store/planStore';
import { DigitalBudgetTableRowData } from 'pages/calculator/MediaPlanning/common/BudgetTable/interfaces';

/**
 * Groups budget data by touchpoint name (e.g. YouTube, Meta, TikTok).
 * For each touchpoint:
 * - Aggregates metrics (impressions, reach, clicks, video views, budget)
 * - Maintains children array with funnel level data (e.g. RF, Awareness)
 * - Includes tech costs (DSP, ad server) in total budget calculation
 */

export const groupCalculatedBudgetTouchpointData = (
  data: (CalculatedBudget | undefined)[]
): DigitalBudgetTableRowData[] | [] => {
  const groupedData = new Map<string, DigitalBudgetTableRowData>();

  if (data.length === 0) {
    return [];
  }

  data.forEach((item) => {
    if (!item) {
      return;
    }

    const existingGroup = groupedData.get(item.touchpointName);

    if (existingGroup) {
      existingGroup.budget.value += item.budget.value;
      existingGroup.reach = (existingGroup.reach || 0) + (item.reach || 0);
      existingGroup.clicks = (existingGroup.clicks || 0) + (item.clicks || 0);
      existingGroup.impressions =
        (existingGroup.impressions || 0) + (item.impressions || 0);
      existingGroup.videoViews =
        (existingGroup.videoViews || 0) + (item.videoViews || 0);
      existingGroup.techCost = {
        dsp: (existingGroup.techCost?.dsp || 0) + (item.techCost?.dsp || 0),
        adServer:
          (existingGroup.techCost?.adServer || 0) +
          (item.techCost?.adServer || 0),
      };
      existingGroup.children = existingGroup.children || [];
      existingGroup.children.push(item);
    } else {
      groupedData.set(item.touchpointName, {
        touchpointName: item.touchpointName,
        budget: { ...item.budget },
        impressions: item.impressions,
        reach: item.reach,
        clicks: item.clicks,
        videoViews: item.videoViews,
        techCost: { ...item.techCost },
        children: [item],
      });
    }
  });

  return Array.from(groupedData.values());
};
